// This file is generated by @tableau/module-dev-scripts/src/scripts/compile.ts
// Use this only for good or for awesome.
export const packageVersion = '9.57.0';
